import { Loadable } from 'foundations-components/transitional/utils/Loadable';
export default Loadable({
  loader: () => import( /* webpackChunkName: "asset-comment-button" */'./AssetCommentButton').then(mod => mod.default)
});